<template>
<div class="pp-ui-noselect pp-ui-container" @mousemove="onmouseover" ref="container">
    <div class="pp-ui-video-container" :class="{'pp-ui-show-controls': showControls}">
        <slot>
        </slot>
    </div>

    <div class="pp-ui-overlay pp-ui-stretch"
         :class="{
                'pp-ui-hidden': !isIdle,
              }">
      <slot name="idle">
      </slot>
    </div>

    <div class="pp-ui-overlay pp-ui-stretch"
         :class="{
                'pp-ui-hidden': !isError,
              }">
      <slot name="error">
      </slot>
    </div>

    <transition name="pp-ui-fade">
      <div class="pp-ui-overlay pp-ui-stretch"
           v-if="fullscreenThumbs && !player.fullscreen && !(isIdle || isError || player.showOptions || !showControls || player.ad.active)"
           :class="{
                  'pp-ui-no-interaction': player.showOptions || !showControls || player.ad.active
                }">
        <PPThumbnail full-height style="height: 100%; padding: 0;"/>
      </div>
    </transition>
    <transition name="pp-ui-fade">
      <div class="pp-ui-overlay pp-ui-stretch"
           v-if="!(isIdle || isError || player.showOptions || !showControls || player.ad.active)"
           :class="{
                  'pp-ui-no-interaction': player.showOptions || !showControls || player.ad.active
                }">

        <slot name="controls">
          <slot name="controls-top">
            <div class="pp-ui-row">
              <slot name="title">
                <div v-html="title"></div>
              </slot>
              <div style="flex-grow: 1"></div>
              <PPButtonCast :chromecast="chromecast" class="pp-ui-button-24" style="margin-right: 16px"/>
              <PPButtonAirPlay :airplay="airplay" class="pp-ui-button-24" style="margin-right: 16px"/>
              <PPButtonToggleFullscreen class="pp-ui-button-24" style="margin-right: 16px"/>
              <PPButtonOptions class="pp-ui-button-24"/>
            </div>
          </slot>

          <slot name="controls-center">
            <div style="flex-grow: 1"></div>
          </slot>
          <slot name="controls-bottom">
            <div class="pp-ui-row" style="background-color: transparent; padding: 0"
                 v-if="!fullscreenThumbs || player.fullscreen">
              <PPThumbnail :thumb-width="thumbWidth"/>
            </div>
            <div class="pp-ui-row">
              <PPBarHorizontalSeek style="width: 100%" @hovering="onmouseover"/>
              <div style="flex-basis: 0; flex-grow: 1;">
                <PPButtonToggleMuted class="pp-ui-button-24"/>
              </div>
              <div style="">
                <PPButtonTogglePlayPause />
              </div>
              <div style="flex-basis: 0; flex-grow: 1; text-align: right;">
                <PPLabelCurrentTime />
                <span>&nbsp;/&nbsp;</span>
                <PPLabelDuration />
              </div>
            </div>
          </slot>
        </slot>
      </div>

    </transition>

    <transition name="pp-ui-fade">
      <div class="pp-ui-overlay pp-ui-stretch pp-ui-overlay-no-transition pp-ui-pass-clicks"
           v-if="!(isIdle || isError || !showControls || !player.ad.active)"
           :class="{
                  'pp-ui-no-interaction': !showControls || !player.ad.active
                }">
          <div class="pp-ui-row" style="padding: 0; padding-top: 8px; padding-bottom: 8px;">
              <div style="flex-basis: 0; flex-grow: 1; padding-left: 10px;">
                  {{player.ad.title}}
              </div>
              <div style="flex-basis: 0; flex-grow: 1; text-align: right; padding-right: 10px;">
                  {{player.ad.positionInSequence}}/{{player.ad.sequenceLength}}
              </div>
          </div>
          <div style="flex-grow: 1"></div>
          <div class="pp-ui-row" :class="{'pp-ui-catch-clicks': player.ad.active || player.ad.loading}" style="padding: 0;">
              <div style="flex-basis: 0; flex-grow: 1; padding-left: 10px; padding-bottom: 2px; padding-top: 6px;">
                  <PPButtonTogglePlayPause class="pp-ui-button-22" style="margin-right: 16px;">
                      <PlayIconSmall slot="play" />
                      <PauseIconSmall slot="pause"/>
                  </PPButtonTogglePlayPause>
                  <PPButtonToggleMuted class="pp-ui-button-22" />
              </div>
              <div style="flex-basis: 0; flex-grow: 1; text-align: right; padding-right: 10px;">
                  <PPLabelTimeLeft :period-time="false"/>
              </div>
          </div>
      </div>
    </transition>

    <div class="pp-ui-overlay pp-ui-stretch"
         :class="{'pp-ui-hidden': false}"
         :style="{'pointer-events': player.showOptions ? 'auto' : 'none'}">
        <div class="pp-ui-row"
             style="height: 100%; padding: 0; background-color: transparent;">

            <div style="flex-grow: 1; height: 100%"
                 @click="player.showOptions = false; userHovering = false;"></div>

            <div style="" class="pp-ui-options-bar"
                 :class="{'pp-ui-options-bar-show': player.showOptions && !(player.ad.active || player.ad.loading)}">


                <div class="pp-ui-options-title">
                    <div class="pp-ui-clickable"
                         @click="player.optionsSection = player.optionsSection === 'audio' ? null : 'audio'">
                        Audio
                        <div class="pp-ui-options-subtitle" v-if="player.activeTracks.audio">
                          <span v-if="player.activeTracks.audio.track.label">{{player.activeTracks.audio.track.label }}</span>
                          <span v-else>{{player.activeTracks.audio.track.language | language }}</span>
                        </div>
                    </div>

                    <div style="" class="pp-ui-options-selection"
                         :class="{'pp-ui-options-bar-collapsed': player.optionsSection !== 'audio'}">
                        <div v-for="rendition in this.player.audioTracks"
                             @click="player.activeTracks.audio = rendition"
                             v-bind:key="rendition.id"
                             class="pp-ui-options-title pp-ui-clickable"
                             :class="{'pp-ui-options-selected': player.activeTracks.audio && player.activeTracks.audio.id === rendition.id}">

                            <span v-if="rendition.track.label">{{rendition.track.label}}</span>
                            <span v-else>{{rendition.track.language | language}}</span>
                            <div class="pp-ui-options-subtitle">
                                {{rendition.track.channelsCount | channels}} {{rendition.codec | codec}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="pp-ui-options-title">
                    <div class="pp-ui-clickable"
                         @click="player.optionsSection = player.optionsSection === 'text' ? null : 'text'">
                        Subtitles
                        <div class="pp-ui-options-subtitle">
                            <span v-if="player.activeTracks.text">
                                <span v-if="player.activeTracks.text.track.language">
                                    {{player.activeTracks.text.track.language | language }} {{player.activeTracks.text.track.kind | kind(true)}}
                                </span>
                                <span v-else>
                                    {{player.activeTracks.text.track.label}} {{player.activeTracks.text.track.kind | kind(true)}}
                                </span>
                            </span>
                            <span v-else>Off</span>
                        </div>
                    </div>

                    <div style="" class="pp-ui-options-selection"
                         :class="{'pp-ui-options-bar-collapsed': player.optionsSection !== 'text'}">
                        <div @click="player.activeTracks.text = null"
                             class="pp-ui-options-title pp-ui-clickable"
                             :class="{'pp-ui-options-selected': !player.activeTracks.text}">
                            Off
                        </div>
                        <div v-for="rendition in player.textTracks.filter(track => track.track.kind !== 'forced')"
                             @click="player.activeTracks.text = rendition"
                             v-bind:key="rendition.id"
                             class="pp-ui-options-title pp-ui-clickable"
                             :class="{'pp-ui-options-selected': player.activeTracks.text && player.activeTracks.text.id === rendition.id}">
                            <span v-if="rendition.track.language">
                                {{rendition.track.language | language }} {{rendition.track.kind | kind(true)}}
                            </span>
                            <span v-else>
                                {{rendition.track.label}} {{rendition.track.kind | kind(true)}}
                            </span>
                            <div class="pp-ui-options-subtitle">
                                {{rendition.track.mimeType | codec}}
                            </div>
                        </div>
                    </div>
                </div>


                <div class="pp-ui-options-title">
                    <div :class="{'pp-ui-clickable': player.canSelectVideoTracks}"
                         @click="toggleVideoTrackSection">
                        Video
                        <div class="pp-ui-options-subtitle">
                            <span v-if="!player.activeTracks.abr && player.activeTracks.video">
                                {{player.activeTracks.video | resolution}} @ {{player.activeTracks.video | bitrate}}
                            </span>
                            <span v-else>
                              <span v-if="player.activeTracks.video && player.activeTracks.video.bandwidth">
                                Auto  <span v-if="player.activeTracks.video">({{player.activeTracks.video | resolution}} @ {{player.activeTracks.video | bitrate}})</span>
                              </span>
                              <span v-else>
                                Auto  <span v-if="player.activeTracks.video && player.activeTracks.video.width">({{player.activeTracks.video | resolution}})</span>
                              </span>
                            </span>
                        </div>
                    </div>

                    <div style="" class="pp-ui-options-selection"
                         :class="{'pp-ui-options-bar-collapsed': player.optionsSection !== 'video'}">
                        <div @click="player.activeTracks.video = null; player.activeTracks.abr = true;"
                             class="pp-ui-options-title pp-ui-clickable"
                             :class="{'pp-ui-options-selected': player.activeTracks.abr}">
                            Auto
                        </div>
                        <div v-for="track in this.player.videoTracks"
                             @click="player.activeTracks.video = track; player.activeTracks.abr = false;"
                             v-bind:key="track.id"
                             class="pp-ui-options-title pp-ui-clickable"
                             :class="{'pp-ui-options-selected': !player.activeTracks.abr && player.activeTracks.video && player.activeTracks.video.id === track.id}">
                            {{track | resolution}} @ {{track | bitrate}}
                        </div>
                    </div>
                </div>
                <slot name="extra-options">

                </slot>


            </div>

        </div>

        <div class="pp-ui-overlay pp-ui-stretch pp-ui-overlay-fast-transition"
             style="pointer-events: none; display: flex; align-items: center; justify-content: center;"
             v-if="player.loading && !chromecast.isCasting"
             :class="{'pp-ui-fade-out': player.showOptions || !player.loading}">
            <PPSpinner />
        </div>

        <div class="pp-ui-overlay pp-ui-stretch pp-ui-overlay-fast-transition"
             style="pointer-events: none; display: flex; align-items: center; justify-content: center;"
             v-if="player.ad.active && player.ad.loading"
             :class="{'pp-ui-fade-out': !player.ad.active || !player.ad.loading}">
            <PPSpinner />
        </div>

         <div class="pp-ui-overlay pp-ui-stretch pp-ui-overlay-fast-transition pp-ui-osd-label"
             style="pointer-events: none; display: flex; align-items: center; justify-content: center;"
             v-if="chromecast.isCasting"
             :class="{'pp-ui-fade-out': !chromecast.isCasting}">
            Casting to {{chromecast.receiverName}}
        </div>
    </div>
</div>

</template>

<script>
  import {PPComponentMixin} from "../mixins";
  import PlayIconSmall from '../../src/style/assets/play.svg';
  import PauseIconSmall from '../../src/style/assets/pause.svg';
  import {PPCodecFilters, PPLanguageFilters} from "../../src/mixins";
  import PPButtonToggleFullscreen from "./PPButtonToggleFullscreen.vue";
  import PPButtonOptions from "./PPButtonOptions.vue";
  import PPThumbnail from "./PPThumbnail.vue";
  import PPBarHorizontalSeek from "./PPBarHorizontalSeek.vue";
  import PPSpinner from "./PPSpinner.vue";
  import PPLabelTimeLeft from "./PPLabelTimeLeft.vue";
  import PPButtonToggleMuted from "./PPButtonToggleMuted.vue";
  import PPButtonTogglePlayPause from "./PPButtonTogglePlayPause.vue";
  import PPLabelDuration from "./PPLabelDuration.vue";
  import PPLabelCurrentTime from "./PPLabelCurrentTime.vue";
  import PPButtonCast from "./PPButtonCast.vue";
  import PPButtonAirPlay from "./PPButtonAirPlay.vue";

  export default {
    name: "PPPlayerDefault",
    mixins: [PPComponentMixin, PPCodecFilters, PPLanguageFilters],
    components: {
      PPButtonOptions,
      PPThumbnail,
      PPSpinner,
      PPLabelTimeLeft,
      PPButtonTogglePlayPause,
      PPLabelCurrentTime,
      PPLabelDuration,
      PPButtonToggleMuted,
      PPBarHorizontalSeek,
      PPButtonToggleFullscreen,
      PPButtonCast,
      PPButtonAirPlay,
      PlayIconSmall, PauseIconSmall
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      fullscreenThumbs: {
        type: Boolean,
        default: false
      },
      trackHovering: {
        type: Boolean,
        default: true
      },
      autoHideUi: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        hoverTimer: null,
        userHovering: false,
        container: null
      }
    },
    mounted () {
      this.container = this.$refs.container;
    },
    watch: {
      'player.thumb.current': function (n) {
        // watch the thumb. If we get a null thumb we call onmouseover to make
        // sure that the user hover timer is triggered one more time. We do not
        // want the controls to disappear all of a sudden in case the user was
        // touching or hovering over a single thumb for more than the threshold
        if (n === null) {
          this.onmouseover();
        }
      }
    },
    computed: {
      showControls () {
        if (!this.autoHideUi) {
          return this.player.showControls
        }
        return this.userHovering || this.player.status === 'paused' || this.player.thumb.current !== null ||
          this.player.thumb.position !== 0
      },
      isIdle () {
        return this.player && this.player.status === 'idle'
      },
      isError () {
        return this.player && this.player.status === 'error'
      },
      thumbWidth () {
        if(!this.container) return 0;
        let height = this.container.offsetHeight;

        return height < 300 && !this.player.fullscreen ? 65 : 200;
      }
    },
    methods: {
      onmouseover() {
        if(!this.trackHovering) {
          return;
        }
        if(this.hoverTimer) {
          clearTimeout(this.hoverTimer);
        }
        this.userHovering = true;
        this.hoverTimer = setTimeout(() => {
          this.userHovering = false;
        }, 2000)
      },
      toggleVideoTrackSection() {
        if (!this.player.canSelectVideoTracks) {
          return
        }

        if (this.player.optionsSection === 'video') {
          this.player.optionsSection = null
        } else {
          this.player.optionsSection = 'video'
        }
      },
    },

  }
</script>
